// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticker-img[data-v-5d66aad0]{transition-property:all;transition-duration:.3s;transition-timing-function:cubic-bezier(.4,0,.2,1);height:100%;width:100%;aspect-ratio:1/1}@media (min-width:992px){.nav-fixed-container .sticker-img[data-v-5d66aad0]{max-height:60px}}", ""]);
// Exports
module.exports = exports;
